import React from 'react';
import Select from 'react-select';

const ContactTypes = [
  'National Coordination Agency',
  'UN Programme of Action on Small Arms (PoA)',
  'International Tracing Instrument (ITI)'
];

const ContactTypesShort = [
  'National Coordination Agency',
  'PoA',
  'ITI'
];

class NationalContactsTypeSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || null
    };
  }

  onChange(value) {
    this.setState(
      { value },
      () => this.props.onSelect(value)
    );
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value !== undefined && value !== this.state.value) {
      this.setState({ value });
    }
  }

  buildUpOptions() {
    const options = ContactTypes.map(type =>
      Object.assign({}, { label: type, value: type })
    );
    options.unshift({ label: 'All types', value: '' });
    return options;
  }

  render() {
    return (
      <Select
        onChange={ value => this.onChange(value) }
        value={ this.state.value }
        className="national-contact-select country-select-list"
        name="national-contact-select"
        placeholder="Select a type of contact"
        clearable={ false }
        options={ this.buildUpOptions() }
      />
    );
  }
}

export default NationalContactsTypeSelect;
export {
  ContactTypes,
  ContactTypesShort
};



// WEBPACK FOOTER //
// ./src/components/NationalContacts/NationalContactsTypeSelect.js